import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles/index";
import { Button, Typography } from "material-ui";
import { Comment } from "material-ui-icons";

const styleSheet = theme => ({
    root: {
        display: "flex",
        alignItems: "center"
    },
    button: {
        boxShadow: "none"
    },
    comment: {},
    wrapper: {
        margin: theme.spacing.unit,
        position: "relative"
    }
});

class CommentButton extends Component {
    static propTypes = {
        numComments: PropTypes.number.isRequired,
        onClick: PropTypes.func,
        classes: PropTypes.object.isRequired
    };

    static defaultType = {
        onClick: () => {}
    };

    render() {
        const { numComments, classes, onClick } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.wrapper}>
                    <Button
                        fab
                        mini
                        style={{ boxShadow: "none" }}
                        color="default"
                        className={classes.button}
                        onClick={onClick}>
                        <Comment className={classes.comment} />
                    </Button>
                </div>
                <div className={classes.wrapper}>
                    <Typography type="body1">
                        {numComments}
                    </Typography>
                </div>
            </div>
        );
    }
}

export default withStyles(styleSheet)(CommentButton);



// WEBPACK FOOTER //
// ./src/components/CommentButton.jsx